
import React from 'react'
import Header from '../components/header/Header'
import Blog from '../components/blog/Blog'
import Footer from '../components/footer/Footer'

const Blogs = () => {
  return (
    <>
    <Header/>
    <Blog/>
    <Footer/>
    </>
  )
}

export default Blogs